<div class="text-center">
  <h1 class="h4 text-uppercase">{{ 'auth.login.heading' | translate }}</h1>
</div>

<form ngForm [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <app-form-group
      [formControl]="this.loginForm.controls.email"
      type="email"
      name="email"
      label="{{ 'auth.login.form.email.label' | translate }}"
      autocomplete="email"
      [errorMessages]="{
        required: ('auth.login.form.email.validation_messages.required' | translate),
        email: ('auth.login.form.email.validation_messages.email' | translate),
      }"></app-form-group>
  </div>

  <div class="row mt-2">
    <app-form-group
      [formControl]="this.loginForm.controls.password"
      type="password"
      name="password"
      label="{{ 'auth.login.form.password.label' | translate }}"
      autocomplete="current-password"
      [errorMessages]="{required: ('auth.login.form.password.validation_messages.required' | translate)}">
    </app-form-group>
  </div>

  <div class="row my-3">
    <div class="col-12">
      <button
        [disabled]="loginForm.invalid" class="btn btn-primary w-100"
        type="submit">{{ 'auth.login.form.submit_btn' | translate }}
      </button>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-12 justify-content-center d-flex">
      <a class="btn" routerLink="/auth/forgot-password">{{ 'auth.login.forgot_password' | translate }}</a>
    </div>
  </div>
</form>
